var _path, _circle, _path2, _path3, _path4, _path5, _path6, _circle2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04School(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9073 32.0569C22.0224 31.8556 22.2045 31.7015 22.4194 31.6143C28.2762 29.2376 32.4065 23.4924 32.4065 16.7826C32.4065 7.94601 25.243 0.782562 16.4065 0.782562C7.56994 0.782562 0.406494 7.94601 0.406494 16.7826C0.406494 23.5786 4.64355 29.385 10.6201 31.7042C10.8414 31.7901 11.0293 31.9465 11.1471 32.1526L14.7634 38.4811C15.5312 39.8247 17.4686 39.8247 18.2364 38.4811L21.9073 32.0569Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4065,
    cy: 16.7826,
    r: 13.5,
    fill: "#291F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5516 13.3132H10.2612V22.7673H10.2612C10.2614 23.159 13.0127 24.4478 16.4064 24.4478C19.8003 24.4478 22.5516 23.1589 22.5516 22.7673H22.5516V13.3132Z",
    fill: "#8F87F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 24.4478C19.8001 24.4478 22.5514 23.1589 22.5514 22.7673H16.4062V24.4478Z",
    fill: "#353071"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2657 15.0436L16.3932 11.2411L22.5553 15.8471L22.5553 22.7755H16.4008L16.4004 20.6945L10.2682 16.602L10.2657 15.0436Z",
    fill: "#353071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47385 14.456C7.15334 14.2613 7.15334 13.7961 7.47385 13.6014L15.8873 8.48983C16.2063 8.29601 16.6067 8.29601 16.9257 8.48983L25.3391 13.6014C25.6596 13.7961 25.6596 14.2613 25.3391 14.456L16.9257 19.5676C16.6067 19.7614 16.2063 19.7614 15.8873 19.5676L7.47385 14.456Z",
    fill: "#8F87F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8311 18.4226L21.3556 18.6869L21.3771 16.8577L16.7387 14.0397C16.5879 13.948 16.5871 13.7295 16.7372 13.6366C16.8128 13.5899 16.9082 13.5895 16.9842 13.6357L21.8339 16.5821L21.8311 18.4226Z",
    fill: "#E7E6F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6141,
    cy: 18.6856,
    r: 0.472705,
    fill: "#4841A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0788 18.7558H21.1333L20.6606 20.6466H22.5515L22.0788 18.7558ZM22.5515 20.6466C22.5515 20.9077 22.1283 21.1193 21.6061 21.1193C21.084 21.1193 20.6607 20.9077 20.6607 20.6466H22.5515Z",
    fill: "#4841A6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04School);
export default __webpack_public_path__ + "static/media/04_school.d8db84f2dcfc901909c05d13c36f15a8.svg";
export { ForwardRef as ReactComponent };